import { useEffect, useState } from "react";
import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { Icon, Text } from "@utils/helper";
import { IconButton, Tooltip } from "@mui/material";
import { useLanguageToggle } from "Hooks/redirectionHelperHooks";

const LangChange = ({ iconWhite, showFullTitle = false }) => {
  const [title, setTitle] = useState("EN");
  const { t, lang } = useTranslation();
  const { language_toggler } = useLanguageToggle(lang);

  useEffect(() => {
    lang === "ar"
      ? setTitle(showFullTitle ? "English" : "EN")
      : setTitle(showFullTitle ? "عربي" : "ع");
  }, [lang, showFullTitle]);

  return (
    <Tooltip title={t("nav.change_language")}>
      <IconButton
        onClick={language_toggler}
        size="small"
        aria-haspopup="menu"
        sx={{ width: "fit-content" }}
      >
        <div
          className={buildClass(
            "flex items-center gap-1 justify-center",
            "cursor-pointer text-lg font-semibold w-11 h-11"
          )}
        >
          {!showFullTitle && (
            <Icon
              id="r4-c2"
              width={17}
              height={15}
              color={iconWhite ? "#FFFFFF" : "#000000"}
              className="!w-4 !h-4"
            />
          )}
          <Text
            color={iconWhite ? "#FFFFFF" : "#333333"}
            className="!block select-none rtl:!top-0.5"
          >
            {title}
          </Text>
        </div>
      </IconButton>
    </Tooltip>
  );
};

export default LangChange;
